<template>
  <section class="section">
    <p>Sign In</p>
    <b-input type="text" v-model="email" placeholder="Email" />
    <br />
    <b-input type="password" v-model="password" placeholder="Password" />
    <br />
    <b-button type="is-primary" @click="login">Login</b-button>
    <br />
    <b-button icon-left="google" @click="googleSignin">Sign In with Google</b-button>

    <span>
      or create an account
      <router-link to="register">Sign Up</router-link>
    </span>
  </section>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            this.$router.replace('home');
          },
          (err) => {
            throw new Error(err);
          },
        );
    },

    /** Sign in with Google account */
    googleSignin() {
      const provider = new firebase.auth.GoogleAuthProvider();

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
          this.$router.replace('home');
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
  },
};
</script>
